export default __webpack_public_path__ + "static/media/p-12.63627515.svg";